import React from 'react'
import { InstallationInvitationModel } from 'src/Libs/installation-rights-management/models'
import { Typography } from '@mui/material'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'

interface Props {
  item?: InstallationInvitationModel
}

const InvitationTypeColumn: React.VFC<Props> = () => {
  const { t } = useCustomTranslation()
  return <Typography variant={'body2'}>{t('common.accountType.user')}</Typography>
}

export default InvitationTypeColumn
